import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
import API from "../../../apiService";
import apiService from "../../../apiService";
import { setRef } from "@fullcalendar/react";
import { useContext } from "react";
import { DetilPxContext } from "context";

const TelaahModal = ({ show, onHide, data }) => {
  const dat = useContext(DetilPxContext);

  useEffect(() => {
    if (show) {
      setantrian(dat.selected ? dat.selected.queue : 0);
      getReferensi();
    }
  }, [show]);
  const [antrian, setantrian] = useState(0);
  const [ref, setref] = useState([]);
  const [refout, setrefout] = useState([]);

  const getReferensi = async () => {
    const res = await apiService.get("resep/get_refrensi");
    if (res.code == 200) {
      let data = [];
      let dataout = [];
      res.data.in.map((a) => {
        data.push({ ...a, nilai: "ya" });
      });
      res.data.out.map((a) => {
        dataout.push({ ...a, nilai: "ya" });
      });
      setref(data);
      setrefout(dataout);
    } else {
      setref([]);
    }
  };
  const chageNilai = (idx) => (event) => {
    const target = event.target;
    const refx = [...ref];
    const value = target.type === "checkbox" ? target.checked : target.value;
    if (value) {
      refx[idx].nilai = "ya";
    } else {
      refx[idx].nilai = "tidak";
    }
    setref(refx);
  };
  const chageNilaiOut = (idx) => (event) => {
    const target = event.target;
    const refx = [...refout];
    const value = target.type === "checkbox" ? target.checked : target.value;
    if (value) {
      refx[idx].nilai = "ya";
    } else {
      refx[idx].nilai = "tidak";
    }
    setrefout(refx);
  };

  const simpan = async () => {
    let param = {
      hasil_telaah: {
        in: ref,
        out: refout,
      },
    };
    console.log(data);
    console.log(param);
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
      }}
      size={"lg"}
      centered
    >
      <Modal.Body className={"pb-0"}>
        <h4 className={"mb-0"}>Telaah Resep</h4>
      </Modal.Body>
      <Modal.Body>
        <div className={"row"}>
          <div className={"col-12"}>
            <br />
            <div className="form-group row mb-0 card-body">
              <label
                htmlFor="example-text-input"
                className="col-md-2 col-form-label col-form-label-sm"
              >
                <b>Antrian</b>
              </label>
              <div className="col-md-8">
                <div className="row">
                  <input
                    className="form-control form-control-sm"
                    type="text"
                    id="example-text-input"
                    name="antrian"
                    onChange={(e) => setantrian(e.target.value)}
                    value={antrian}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className=" col-md-6">
                <div>Penerimaan</div>
                <table className={"table table-bordered table-responsive"}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Ceklis Penerimaan Resep</th>
                      <th>Nilai</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ref.map((a, k) => (
                      <tr key={k}>
                        <td>{k + 1}</td>
                        <td>{a.telaah_item}</td>
                        <td>
                          <label className="custom-toggle custom-toggle-success">
                            <input
                              type="checkbox"
                              checked={a.nilai === "ya" ? "checked" : ""}
                              onChange={chageNilai(k)}
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              data-label-off="tidak"
                              data-label-on="ya"
                            />
                          </label>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className=" col-md-6">
                <div>Penyerahan</div>
                <table className={"table table-bordered table-responsive"}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Ceklis Penerimaan Resep</th>
                      <th>Nilai</th>
                    </tr>
                  </thead>
                  <tbody>
                    {refout.map((a, k) => (
                      <tr key={k}>
                        <td>{k + 1}</td>
                        <td>{a.telaah_item}</td>
                        <td>
                          <label className="custom-toggle custom-toggle-success">
                            <input
                              type="checkbox"
                              checked={a.nilai === "ya" ? "checked" : ""}
                              onChange={chageNilaiOut(k)}
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              data-label-off="tidak"
                              data-label-on="ya"
                            />
                          </label>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className={"pt-0"}>
        <button
          type={"button"}
          onClick={() => simpan()}
          className={"btn btn-success"}
        >
          Simpan
        </button>
        <button type={"button"} className={"btn btn-danger"} onClick={onHide}>
          Tutup
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TelaahModal;
